import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Box, VStack } from "../../components/utils";
import { useGetOptionBuyback } from "../../queries/optionBuyback";
import BCHeader from "../../shared/BCHeader";
import BuybackDetails from "./Buybackdetails";
import BuybackEmployeeDetails from "./BuybackEmployeeDetails";
import BuybackEmployeeList from "./BuybackOffersList";
import ExerciseDetails from "./ExerciseDetails";
import useIsMobile from "../../utils/detectDevice";
import {
  MonetaryTransactionType,
  OptionBuyBackDetails,
} from "../../types/OptionBuyback";

function StartBuyback() {
  const { id } = useParams();
  const _id = id ?? "";
  const navigate = useNavigate();
  const { data: buybackOverview, refetch, isFetching } = useGetOptionBuyback();
  const optionBuybackOverview = buybackOverview ?? [];
  const [buyback, setBuyback] = useState<OptionBuyBackDetails>();
  useEffect(() => {
    refetch();
    if (!isFetching) {
      const isValidBuyBack = optionBuybackOverview.find(
        (optionBuyBack) => optionBuyBack.id === _id
      );
      if (!isValidBuyBack) {
        toast(`You don't have permission to access ${_id} buyback`, {
          type: "error",
          autoClose: 3000,
        });
        navigate("/options/esopTransactions");
      } else {
        setBuyback(isValidBuyBack);
      }
    }
  }, [optionBuybackOverview, _id]);

  const { isMobile } = useIsMobile();

  if (!buyback) {
    return (
      <VStack className="gap-4 py-3">
        <BCHeader bcTitle="Liquidity Event Planning and Administration" />
        <Box
          className={`${
            isMobile ? "w-full" : "w-3/5"
          } px-5 py-5 border-dashed border border-[#FFC700] bg-yellow-50`}
        >
          <p className="text-sm font-medium text-black">Loading...</p>
        </Box>
      </VStack>
    );
  }

  return (
    <VStack className="gap-4 py-3">
      <BCHeader
        bcTitle="Liquidity Event Planning and Administration"
        bcSubTitle={buyback?.eventName}
      />
      <Box
        className={`${
          isMobile ? "w-full" : "w-3/5"
        } px-5 py-5 border-dashed border border-[#FFC700] bg-yellow-50`}
      >
        <p className="text-sm font-medium text-black">
          {`${
            buyback?.transactionType !== MonetaryTransactionType.BUYBACK
              ? "Liquidity programme/program"
              : "Options"
          } ${
            buyback?.transactionType === MonetaryTransactionType.BUYBACK
              ? "Buy Back"
              : ""
          } started successfully`}
        </p>
      </Box>
      <div className="gap-4 px-4 py-4 space-y-4 bg-[#fefefe]">
        {((buyback &&
          buyback.transactionType === MonetaryTransactionType.EXERCISE) ||
          (buyback &&
            buyback.transactionType ===
              MonetaryTransactionType.EXERCISE_LIQUIDITY)) && (
          <ExerciseDetails buybackDetail={buyback} />
        )}
        {buyback &&
          buyback.transactionType === MonetaryTransactionType.BUYBACK && (
            <BuybackDetails buybackDetail={buyback} />
          )}
        {buyback && <BuybackEmployeeDetails buybackDetail={buyback} />}
        {buyback && <BuybackEmployeeList buyback={buyback} />}
      </div>
    </VStack>
  );
}

export default StartBuyback;
